import { TrendingDown, TrendingUp } from "lucide-react";
import { usePrices } from "@/lib/usePrices";

const ORDER = ["BTC", "ETH", "SOL", "USDT", "BNB"];
const COLORS = { BTC: "#F7931A", ETH: "#8A92B2", SOL: "#14F195", USDT: "#26A17B", BNB: "#F3BA2F" };

const fmt = (v) => (v >= 1000 ? v.toLocaleString(undefined, { maximumFractionDigits: 0 }) : v >= 1 ? v.toFixed(2) : v.toFixed(4));

export default function PriceTicker({ compact = false }) {
  const data = usePrices();
  if (!data) return null;
  const items = ORDER.filter((s) => data.prices[s]);
  return (
    <div className={`flex items-center gap-1 overflow-x-auto no-scrollbar ${compact ? "" : "px-4 md:px-8 h-9 border-b border-white/[0.05] bg-[#0E0E10]"}`} data-testid="price-ticker">
      {!compact && <span className="live-dot mr-2 shrink-0" />}
      {items.map((s) => {
        const p = data.prices[s];
        const up = p.change_24h >= 0;
        return (
          <div key={s} className="flex items-center gap-2 px-3 py-1 rounded-lg hover:bg-white/[0.04] shrink-0" data-testid={`price-${s}`} style={{ transition: "background-color 140ms ease" }}>
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: COLORS[s] }} />
            <span className="text-[11px] font-semibold text-zinc-300">{s}</span>
            <span className="font-mono-num text-xs text-white">${fmt(p.usd)}</span>
            <span className={`font-mono-num text-[11px] flex items-center gap-0.5 ${up ? "text-emerald-400" : "text-rose-400"}`}>
              {up ? <TrendingUp size={11} /> : <TrendingDown size={11} />}{up ? "+" : ""}{p.change_24h.toFixed(2)}%
            </span>
          </div>
        );
      })}
      {!compact && <span className="ml-auto text-[10px] text-zinc-500 uppercase tracking-widest shrink-0 hidden md:inline">Live · {data.source}</span>}
    </div>
  );
}
